<template>
  <div class="bgxq-02">
    <!-- 循环显示物流信息 -->
    <div class="bgxq-03" style="font-size: 16px;padding-left: 8px;background: #FEF6EE;">
      <span>运单号：<b>{{json[0].value}}</b></span>

    </div>
    <input type="hidden">
    <!-- 物流详情 -->
    <div class="bgxq-05">
      <div class="package-status">
        <div class="status-box" style="float: none;margin-left: 230px">
          <ul class="status-list" style="margin-bottom: 30px">
						<span v-for="(item,i) in json[1].value">
							<li class="latest"></li>
              <li class="latest">
                <!--<span class="latest-bfdian"></span>-->
                <span class="date">
                  <span>{{item[0].value}}</span>
                </span>
                <span class="text">{{item[1].value}}</span>
								</li>
						</span>
          </ul>
        </div>
      </div>
      <!--<div class="bgxq-06">-->
        <!--<a class="lookall" href="javascript:lookalllogistic();"-->
           <!--style="margin-left: 50px; line-height: 30px; display: none;">查看全部<i class="uk-icon-angle-down"></i> </a>-->
      <!--</div>-->
    </div>
    <div class="bgxq-07">
      <h3>
				<span>
					<b>海外仓：</b>
          <!--<img src="./鼎丰转运—美国免税转运, 负责认真稳定时效2_files/m-qz.jpg">-->
          中国大陆包裹
				</span>
      </h3>
      <div class="bgxq-07-01">
        <div class="">
          <div class="">
            <!-- <div class="bgxq-07-03">包裹信息：</div> -->
            <div class="">
              <div class="sdyn-001">
                <div class="shdi-01">
                  <span>分运单号：<span>{{json[2].value}}</span></span>
                </div>
                <!--<div class="shdi-01">-->
                <!--<span>转运线路：<span>基础类</span></span>-->
                <!--</div>-->
                <!--<div class="shdi-01">-->
                <!--<span>出库时间：<span>2025-03-29 05:13:45</span></span>-->
                <!--</div>-->
                <div class="shdi-01">
                  <span>国内收货地址：</span>
                  <span>
										<span>{{json[5].value}}</span>
									</span>
                </div>
              </div>
              <div class="rkxx-01">
                <div class="rkxx-02">入库信息：</div>
                <div class="rkxx-03">
                  <p>
                    <span>快递单号：<span>{{json[6].value}}</span></span>
                  </p>
                  <p>

                    <span>快递公司：<span>{{json[7].value}}</span></span>
                  </p>
                  <p>
                    <span>入库单号：<span>{{json[8].value}}</span></span>
                  </p>
                  <p>
                    <span>入库时间：<span>{{json[9].value}}</span></span>
                  </p>
                  <p>
                    <span>预报时间：<span>{{json[10].value}}</span></span>
                  </p>
                  <p>
                    入库重量：
                    <span>{{json[11].value}}</span>
                  </p>
                  <span>货物描述：</span>
                  <span>{{json[12].value}}</span>
                  <p></p>
                </div>
              </div>
              <div class="rkxx-04">
                <div class="rkxx-02">出库信息：</div>
                <div class="rkxx-05">
                  <p>
                    <span>出库单号：<span>{{json[13].value}}</span></span>
                  </p>
                  <p style="color:#ff5555;">
                    实际重量：<span>{{json[14].value}}</span>
                  </p>
                  <p style="color: red;">
                    实际运费：<span>{{json[15].value}}</span>
                  </p>


                  <!--<p style="color: red;word-break:break-all;">-->
                    <!--<span>增值服务费：</span>-->
                    <!--<span>10.00元</span>-->
                  <!--</p>-->

                  <p style="color: red;word-break:break-all;">
                    <span>总价格：</span>
                    <span>{{json[16].value}}</span>
                  </p>
                </div>
              </div>
              <div class="bkxx-04">
                <div class="rkxx-02">备注信息：</div>
                <div class="bkxx-05">

                  <p style="word-break:break-all;">
                    <span>包裹备注：<span>{{json[17].value}}</span></span>
                  </p>
                </div>
              </div>
              <div class="rkxx-09"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgxq-07-09">
      <div class="bgxq-07-010">预报包裹商品信息：</div>
      <table class="uk-table">
        <thead>
        <tr>
          <th style="width: 150px;text-align: center;">快递单号</th>
          <th style="width: 150px;text-align: center;">商品名称</th>
          <!--<th style="width: 150px;text-align: center;" th:if="${entryDetail.entryDetail.linecode!='usalove'}">品牌</th>-->
          <th style="width: 120px;text-align: center;">商品类别</th>
          <th style="width: 120px;text-align: center;">子类别</th>
          <!--<th style="width: 120px;text-align: center;">规格型号</th>-->
          <th style="width: 120px;text-align: center;">数量</th>
          <!-- <th style="width: 120px;text-align: center;border-right: 0;"> 单价(RMB)</th> -->
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,i) in json[18].value" :key="i">
          <template v-if="i>0">
            <td v-for="(item2,i2) in item" :key="i2">{{item2.value}}</td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="bgxq-07-09">
      <div class="bgxq-07-010">出库包裹商品信息：</div>
      <table class="uk-table">
        <thead>
        <tr>
          <th style="width: 150px;text-align: center;">快递单号</th>
          <th style="width: 150px;text-align: center;">商品名称</th>
          <!--<th style="width: 150px;text-align: center;" th:if="${entryDetail.entryDetail.linecode!='usalove'}">品牌</th>-->
          <th style="width: 120px;text-align: center;">商品类别</th>
          <th style="width: 120px;text-align: center;">子类别</th>
          <!--<th style="width: 120px;text-align: center;">规格型号</th>-->
          <th style="width: 120px;text-align: center;">数量</th>
          <!-- <th style="width: 120px;text-align: center;border-right: 0;"> 单价(RMB)</th> -->
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,i) in json[19].value" :key="i">
          <template v-if="i>0">
            <td v-for="(item2,i2) in item" :key="i2">{{item2.value}}</td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- 显示内件收货人信息 -->
    <div class="bgxq-07-09">
      <div class="bgxq-07-010">
				<span>
  					合包信息
  				</span>
      </div>
      <table class="uk-table">
        <thead>
        <tr>
          <th style="width: 120px;text-align: center;">分运单号</th>
          <th style="width: 500px;text-align: center;">
            内件信息
          </th>
          <th style="width: 400px;text-align: center;">收货人信息</th>
          <th style="width: 150px;text-align: center;">增值服务</th>
          <th style="width: 100px;text-align: center;border-right: 0;">货物保价金额</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,i) in json[20].value" :key="i">
          <template v-if="i>0">
            <td v-for="(item2,i2) in item" :key="i2">{{item2.value}}</td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="bgxq-07-09">
      <div class="bgxq-07-010">增值服务信息：</div>
      <table class="uk-table">
        <thead>
        <tr>
          <th style="border-left: 0;width: 200px;">增值服务</th>
          <th style="width: 136px;">费用（RMB）</th>
          <th style="width: 520px;">详情</th>
          <th style="width: 80px;">操作</th>
          <th style="width: 190px;border-right: 0;">状态</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,i) in json[21].value" :key="i">
          <template v-if="i>0">
            <td v-for="(item2,i2) in item" :key="i2">{{item2.value}}</td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

  let _ = require('lodash')
  export default {
    name: 'df',
    props: ['json'],
    components: {},
    data() {
      return {}
    },
    created() {

    },
    methods: {}
  }
</script>
<style scoped>
  @import './parcel_detail.css';
</style>

<style scoped lang="scss">
  .uk-table td, .uk-table th {
    padding: 8px 8px;
    border-bottom: 1px solid #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_bill/df/index.vue